import http from 'axios';
import { AUTH_SERVER_URL, BASE_AUTH_URL } from 'utils/helpers/consts';
import { IGenericResponseUnique, ITokens, SubDomain, UserToken } from 'utils/types';

const httpInstance = http.create({});

httpInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

export function getAuthToken(params: URLSearchParams) {
  return new Promise<IGenericResponseUnique<ITokens>>((resolve, reject) => {
    httpInstance
      .post(`${AUTH_SERVER_URL}/connect/token`, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(resolve)
      .catch(reject);
  });
}

export function authenticateApi(tenant: string) {
  return new Promise<IGenericResponseUnique<UserToken>>((resolve, reject) => {
    httpInstance
      .post(
        `${BASE_AUTH_URL}/business/1.3/bornlogicauth/authenticate`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.authServerToken}`,
            'X-Company': tenant,
          },
        }
      )
      .then(resolve)
      .catch(reject);
  });
}

export function checkSubDomain(version: string, subDomain: string) {
  return new Promise<IGenericResponseUnique<SubDomain>>((resolve, reject) => {
    httpInstance
      .get(`${BASE_AUTH_URL}/business/${version}/settings/public?business_sub_domain=${subDomain}`)
      .then(resolve)
      .catch(reject);
  });
}
